import "./src/base.css";
import "./src/native.css";
import "./src/utility.css";
import "./src/layout.css";



(async () => {
  // When not building for testing purposes
  console.log(import.meta.env.MODE)
  if (import.meta.env.MODE == "development" ) {
    const i = await import('./js/dev.js');
  }
})();


